import { useMemo } from "react";
import { useAgentEntitlements } from "../features/agentEntitlements/useAgentEntitlements";
import { useDevViewModeOptional } from "../dev/viewMode";
import { isCrmHubEnabled } from "./crmHubFlag";

/** Reactive CRM Hub gate using entitlements package when loaded. */
export function useCrmHubEnabled() {
  const { effectivePackageCode, status } = useAgentEntitlements();
  const devView = useDevViewModeOptional();
  const treatAsAgent = Boolean(devView?.isPackageOverrideActive);

  return useMemo(
    () =>
      isCrmHubEnabled({
        effectivePackageCode:
          status === "ok" ? effectivePackageCode : undefined,
        treatAsAgent,
      }),
    [effectivePackageCode, status, treatAsAgent]
  );
}
